module.exports = __webpack_public_path__ + "img/add-new-image.ec34d1e7.svg";